import React, { Component } from 'react';
import { connect } from 'dva';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Row, Col, Table, Tooltip, Button, Icon, Spin, Modal } from 'antd';
import { Link } from 'dva/router';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent } from '../../../components';
import { PencilIcon, TrashIcon } from '../../Icons';
import { userRoleInCurrentProject } from '../../../selectors/app';
import Roles from '../../../utils/roles';
import {
  ACTION_APP_GO_TO_ROUTE,
  ACTION_APP_SHOW_NOTIFICATION,
  ACTION_APP_ADD_NOTIFICATION,
} from '../../../models/app';
import { ACTION_HEADER_UPDATE } from '../../../models/header';
import {
  ACTION_COUNTRY_REGIONS_LOAD_LIST,
  ACTION_COUNTRY_REGIONS_REMOVE,
} from '../../../models/countryRegions';
import { ROUTE_COUNTRY_REGIONS_NEW } from '../../../routes';
import styles from './../styles.less';

const { Column } = Table;
const pageGroupsActionRole = [Roles.role_super_admin.id];

class CountryRegionsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {},
      removedId: null,
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: ACTION_HEADER_UPDATE,
      payload: {
        title: 'Component.CountryRegions.Title',
        description: 'Component.CountryRegions.Description',
      },
    });

    this.showNotifications();
  }

  getData = (psf) => {
    const filter = { name: this.state.filter.search, client_id: this.props.app.selectedClient.id };
    const payload = { filter, ...psf };

    if (Object.keys(this.state.filter).length > 0) {
      payload.filtered = true;
    }

    return this.props.dispatch({
      type: ACTION_COUNTRY_REGIONS_LOAD_LIST,
      payload,
    });
  };

  showNotifications() {
    this.props.dispatch({ type: ACTION_APP_SHOW_NOTIFICATION });
  }

  addNotification() {
    this.props.dispatch({
      type: ACTION_APP_ADD_NOTIFICATION,
      payload: {
        type: 'success',
        message: 'Common.Success',
        description: 'Component.CountryRegions.Remove.Success.Text',
      },
    });
  }

  goToPageGroupsNew = () => {
    this.props.dispatch({
      type: ACTION_APP_GO_TO_ROUTE,
      payload: { routeName: ROUTE_COUNTRY_REGIONS_NEW },
    });
  };

  removeItemModal = item => () => {
    return Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage(
        { id: 'Component.CountryRegions.Modal.Description' },
        { countryRegionName: item.name },
      ),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk: () => {
        this.removeItem(item.id);
      },
    });
  };

  removeItem = (id) => {
    this.props
      .dispatch({ type: ACTION_COUNTRY_REGIONS_REMOVE, payload: { id } })
      .then((response) => {
        if (response.success) {
          this.addNotification();
          this.showNotifications();
          this.setState({ removedId: id });
        }
      });
  };

  render() {
    const { filter, removedId } = this.state;
    const { loading, userRole } = this.props;
    return (
      <div className={styles.containerLarge}>
        <Sticky
          className="sticky-bar"
          scrollElement=".ant-layout"
          stickyClassName="_sticky"
        >
          <div className="sticky-wrapper">
            <Row>
              <SearchComponent
                self={this}
                fieldPlaceholder={this.props.intl.formatMessage({
                  id: 'Component.CountryRegions.List.SearchByNamePlaceholder',
                })}
              />
              <Col span={14} className="text-right">
                {pageGroupsActionRole.includes(userRole) && (
                  <Button
                    size="large"
                    type="primary"
                    onClick={this.goToPageGroupsNew}
                  >
                    <Icon type="plus" />
                    <FormattedMessage id="Component.CountryRegions.Create" />
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </Sticky>
        <Spin spinning={loading.models.countryRegions}>
          <AjaxTable
            getData={this.getData}
            rowKey="id"
            updateKey={JSON.stringify([filter, removedId])}
          >
            <Column
              dataIndex="name"
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Name' })}
              sorter
              render={item => <div>{item}</div>}
            />
            {pageGroupsActionRole.includes(userRole) && (
              <Column
                title={this.props.intl.formatMessage({
                  id: 'Grid.Column.Actions',
                })}
                key="actions"
                className="text-center"
                width={150}
                fixed="right"
                render={item => (
                  <div className="actions" data-label={item.id}>
                    <Tooltip
                      className="hint action-wrap"
                      placement="top"
                      title={this.props.intl.formatMessage({
                        id: 'Grid.Column.Edit',
                      })}
                    >
                      <Link to={`./${item.id}/edit/`}>
                        <PencilIcon />
                      </Link>
                    </Tooltip>
                    <Tooltip
                      className="hint action-wrap"
                      placement="top"
                      title={this.props.intl.formatMessage({
                        id: 'Grid.Column.Delete',
                      })}
                    >
                      <button onClick={this.removeItemModal(item)}>
                        <TrashIcon />
                      </button>
                    </Tooltip>
                  </div>
                )}
              />
            )}
          </AjaxTable>
        </Spin>
      </div>
    );
  }
}

export default connect(({ app, loading }) => ({
  loading,
  userRole: userRoleInCurrentProject(app),
  app,
}))(injectIntl(CountryRegionsList));



// WEBPACK FOOTER //
// ./src/components/CountryRegions/CountryRegionsList/CountryRegionsList.js